// extracted by mini-css-extract-plugin
module.exports = {"newHeader":"AccoutInfo_newHeader__vBOI3","brand":"AccoutInfo_brand__jtjIZ","logo":"AccoutInfo_logo__ZS48F"};